import React, { useState, useContext, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import nextyn_logo from "../assests/images/NX19.png";
import {
  AiOutlineLogout,
  BsBell,
  IoOpenOutline,
  IoSettingsOutline,
  SlArrowRight,
  RxHamburgerMenu,
} from "../Utils/Icons";
import "./Sidebar.css";
import { Avatar, Divider, Popover } from "antd";
import { Offcanvas } from "react-bootstrap";
import { AiOutlineFileDone } from "react-icons/ai";
import { ApiContext } from "../pages/NotificationApi";
import { setMeetingPage } from "../pages/CloudFeatures/InternalMeetings/Slice/internalMeeting.slice";
import { useDispatch } from "react-redux";
import { authActions } from "../Utils/auth.action";
import { LiaFileInvoiceSolid } from "react-icons/lia";
import hr_policy from "../assests/pdf/human_resource_policy_manual-15jul-2024.pdf";
import useOutsideClick from "../Utils/useOutsideClick";
function Sidebar() {
  const userData = JSON.parse(localStorage.getItem("userData"));
  const [profilePopover, setProfilePopover] = useState(false);
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const wrapperRef = useRef(null);
  // const handleOutsideClick = () => {
  //   setProfilePopover(false); // Reset state or any other action
  // };
  // useOutsideClick(wrapperRef, handleOutsideClick);

  const { notifications } = useContext(ApiContext);
  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.removeItem("userData");
    localStorage.removeItem("token");
    localStorage.removeItem("auth");
    localStorage.removeItem("lastActiveTime");
    localStorage.removeItem("lastLoginTime");
    dispatch(authActions.logout());
  };

  const menuItems = () => {
    return (
      <ul
        className="list-unstyled mainMenuUL"
        style={{
          overflowX: "hidden",
        }}
      >
        {!userData?.data?.roleData?.[0]?.role_permission?.[0]?.dashboard
          ?.view === true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[2]?.expert?.view ===
          true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[11]?.exotel?.view ===
          true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[3]?.live_projects
          ?.view === true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[7]?.completed_projects
          ?.view === true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[8]?.archived_projects
          ?.view &&
        !userData?.data?.roleData?.[0]?.role_permission?.[5]?.call_records
          ?.view === true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[16]
          ?.draftedZoomMeeting?.view === true ? null : (
          <li className="m-0">
            {/* <h5 style={{ fontWeight: 600 }}>FOR YOU</h5> */}
            {userData?.data?.roleData?.[0]?.role_permission?.[0]?.dashboard
              ?.view === true ? (
              <NavLink end to="/dashboard" activeclassname="menu_active">
                <svg
                  stroke="currentColor"
                  fill="none"
                  stroke-width="1.5"
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M2.25 12l8.954-8.955c.44-.439 1.152-.439 1.591 0L21.75 12M4.5 9.75v10.125c0 .621.504 1.125 1.125 1.125H9.75v-4.875c0-.621.504-1.125 1.125-1.125h2.25c.621 0 1.125.504 1.125 1.125V21h4.125c.621 0 1.125-.504 1.125-1.125V9.75M8.25 21h8.25"
                  ></path>
                </svg>
                <span className="menu-text"> Home </span>
              </NavLink>
            ) : null}
            {userData?.data?.roleData?.[0]?.role_permission?.[19]?.invoice
              ?.view === true ? (
              <NavLink
                onClick={() => {
                  localStorage.removeItem("filterStates");
                }}
                to="/dashboard/invoice-generator"
                activeclassname="menu_active"
                className="position-relative"
              >
                <span className="menu-icon-new">
                  <LiaFileInvoiceSolid />
                </span>
                <span className="menu-text"> Invoice Generator </span>{" "}
              </NavLink>
            ) : null}
            {userData?.data?.roleData?.[0]?.role_permission?.[2]?.expert
              ?.view === true ? (
              <NavLink
                onClick={() => {
                  localStorage.removeItem("filterStates");
                }}
                to="/dashboard/expert_search"
                activeclassname="menu_active"
                className="position-relative"
              >
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                    ></path>
                  </svg>
                </span>
                <span className="menu-text"> Experts </span>{" "}
                {notifications?.expertData > 0 ? (
                  <>
                    {/* <span className="sidebarBadge "> */}
                    <span className="sidebarBadge1 ">
                      {/* {notifications?.expertData} */}
                    </span>
                  </>
                ) : null}
              </NavLink>
            ) : null}
            {userData?.data?.roleData?.[0]?.role_permission?.[2]?.expert
              ?.view === true ? (
              <NavLink
                onClick={() => {
                  localStorage.removeItem("filterStates");
                }}
                to="/dashboard/consultant_search"
                activeclassname="menu_active"
                className="position-relative"
              >
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="none"
                    stroke-width="1.5"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M18 18.72a9.094 9.094 0 003.741-.479 3 3 0 00-4.682-2.72m.94 3.198l.001.031c0 .225-.012.447-.037.666A11.944 11.944 0 0112 21c-2.17 0-4.207-.576-5.963-1.584A6.062 6.062 0 016 18.719m12 0a5.971 5.971 0 00-.941-3.197m0 0A5.995 5.995 0 0012 12.75a5.995 5.995 0 00-5.058 2.772m0 0a3 3 0 00-4.681 2.72 8.986 8.986 0 003.74.477m.94-3.197a5.971 5.971 0 00-.94 3.197M15 6.75a3 3 0 11-6 0 3 3 0 016 0zm6 3a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0zm-13.5 0a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z"
                    ></path>
                  </svg>
                </span>
                <span className="menu-text"> Consultants </span>{" "}
                {notifications?.consultant > 0 ? (
                  <>
                    {/* <span className="sidebarBadge"> */}
                    <span className="sidebarBadge1">
                      {/* {notifications?.consultant} */}
                    </span>
                  </>
                ) : null}
              </NavLink>
            ) : null}
            {userData?.data?.roleData?.[0]?.role_permission?.[11]?.exotel
              ?.view === true ? (
              <>
                <NavLink to="/dashboard/exotel" activeclassname="menu_active">
                  <span className="menu-icon-new">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M8.648 6.648L13.29 2H10V1h5v5h-1V2.71L9.352 7.353l-.704-.704zm3.305 2.563a1.567 1.567 0 0 1 1.102.453c.11.11.232.224.367.344l.43.383c.15.135.291.276.421.421.13.146.253.295.368.446.114.15.2.312.257.484.058.172.092.344.102.516a1.568 1.568 0 0 1-.453 1.101c-.266.266-.505.5-.719.704a4.006 4.006 0 0 1-.664.515c-.23.14-.487.245-.773.313a4.696 4.696 0 0 1-1.008.109 6.157 6.157 0 0 1-1.75-.266A9.819 9.819 0 0 1 7.843 14a12.445 12.445 0 0 1-1.741-1.117 15.329 15.329 0 0 1-1.61-1.414c-.505-.51-.974-1.05-1.406-1.617a11.64 11.64 0 0 1-1.102-1.735 10.38 10.38 0 0 1-.718-1.773A6.005 6.005 0 0 1 1 4.625c0-.396.034-.734.102-1.016a2.63 2.63 0 0 1 .312-.765c.14-.23.313-.45.516-.664.203-.214.44-.456.71-.727A1.567 1.567 0 0 1 3.743 1c.26 0 .51.07.75.21.24.142.472.313.696.517.223.203.43.416.617.64.187.224.364.417.53.578a1.567 1.567 0 0 1 .453 1.102 1.4 1.4 0 0 1-.1.547 1.824 1.824 0 0 1-.25.43 2.983 2.983 0 0 1-.329.351c-.12.11-.229.214-.328.313a3.128 3.128 0 0 0-.258.289.46.46 0 0 0-.101.312c0 .063.047.162.14.297a5.3 5.3 0 0 0 .391.484 24.386 24.386 0 0 0 1.211 1.266c.234.23.461.45.68.664.218.214.43.417.633.61.203.192.375.356.515.492.14.135.25.24.328.312a.534.534 0 0 0 .696.063c.093-.068.19-.152.289-.25.099-.1.2-.209.304-.329.104-.12.224-.229.36-.328.135-.099.278-.185.43-.258a1.21 1.21 0 0 1 .554-.101zM11.383 14c.318 0 .583-.029.797-.086a1.93 1.93 0 0 0 .586-.266c.177-.12.343-.26.5-.421.156-.162.346-.352.57-.57.11-.11.164-.24.164-.391 0-.068-.042-.164-.125-.29a6.122 6.122 0 0 0-.313-.421 5.01 5.01 0 0 0-.43-.47c-.16-.155-.317-.299-.468-.429a4.322 4.322 0 0 0-.414-.32c-.125-.083-.224-.125-.297-.125a.545.545 0 0 0-.312.101 1.801 1.801 0 0 0-.29.25c-.093.1-.195.209-.304.329-.11.12-.23.229-.36.328-.13.099-.273.185-.43.258a1.208 1.208 0 0 1-.546.101 1.527 1.527 0 0 1-1.102-.46L4.883 7.39a1.537 1.537 0 0 1-.336-.5 1.655 1.655 0 0 1-.125-.602c0-.203.034-.383.101-.539.068-.156.151-.302.25-.438.1-.135.209-.252.329-.351.12-.099.229-.203.328-.313.099-.109.185-.205.258-.289a.429.429 0 0 0 .101-.312c0-.068-.042-.164-.125-.29a5.085 5.085 0 0 0-.312-.413 6.791 6.791 0 0 0-.43-.469 6.787 6.787 0 0 0-.469-.43 5.674 5.674 0 0 0-.422-.32c-.13-.089-.226-.13-.289-.125a.542.542 0 0 0-.398.164 65.24 65.24 0 0 1-.57.563 3.073 3.073 0 0 0-.422.5 1.9 1.9 0 0 0-.258.586A3.377 3.377 0 0 0 2 4.601c0 .5.08 1.015.242 1.546a9.12 9.12 0 0 0 .672 1.61c.287.541.63 1.068 1.031 1.578.401.51.831.997 1.29 1.46a13.205 13.205 0 0 0 3.046 2.298 8.37 8.37 0 0 0 1.586.664 5.526 5.526 0 0 0 1.516.242z"></path>
                    </svg>
                  </span>
                  <span className="menu-text"> Exotel</span>{" "}
                </NavLink>
              </>
            ) : null}

            {userData?.data?.roleData?.[0]?.role_permission?.[1]?.client
              ?.view ||
            (userData?.data?.roleData?.[0]?.role_permission?.[3]?.live_projects
              ?.view &&
              userData?.data?.roleData?.[0]?.role_permission?.[7]
                ?.completed_projects?.view &&
              userData?.data?.roleData?.[0]?.role_permission?.[8]
                ?.archived_projects?.view) ||
            userData?.data?.roleData?.[0]?.role_permission?.[16]
              ?.draftedZoomMeeting?.view ||
            userData?.data?.roleData?.[0]?.role_permission?.[5]?.call_records
              ?.view ? (
              <Divider
                className="m-2"
                style={{
                  borderColor: "#5c5f623b",
                }}
              />
            ) : null}

            {userData?.data?.roleData?.[0]?.role_permission?.[1]?.client
              ?.view === true ? (
              <NavLink
                to="/dashboard/clients"
                activeclassname="menu_active"
                className="position-relative"
              >
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 640 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M48 48h88c13.3 0 24-10.7 24-24s-10.7-24-24-24H32C14.3 0 0 14.3 0 32V136c0 13.3 10.7 24 24 24s24-10.7 24-24V48zM175.8 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-26.5 32C119.9 256 96 279.9 96 309.3c0 14.7 11.9 26.7 26.7 26.7h56.1c8-34.1 32.8-61.7 65.2-73.6c-7.5-4.1-16.2-6.4-25.3-6.4H149.3zm368 80c14.7 0 26.7-11.9 26.7-26.7c0-29.5-23.9-53.3-53.3-53.3H421.3c-9.2 0-17.8 2.3-25.3 6.4c32.4 11.9 57.2 39.5 65.2 73.6h56.1zm-89.4 0c-8.6-24.3-29.9-42.6-55.9-47c-3.9-.7-7.9-1-12-1H280c-4.1 0-8.1 .3-12 1c-26 4.4-47.3 22.7-55.9 47c-2.7 7.5-4.1 15.6-4.1 24c0 13.3 10.7 24 24 24H408c13.3 0 24-10.7 24-24c0-8.4-1.4-16.5-4.1-24zM464 224a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm-80-32a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM504 48h88v88c0 13.3 10.7 24 24 24s24-10.7 24-24V32c0-17.7-14.3-32-32-32H504c-13.3 0-24 10.7-24 24s10.7 24 24 24zM48 464V376c0-13.3-10.7-24-24-24s-24 10.7-24 24V480c0 17.7 14.3 32 32 32H136c13.3 0 24-10.7 24-24s-10.7-24-24-24H48zm456 0c-13.3 0-24 10.7-24 24s10.7 24 24 24H608c17.7 0 32-14.3 32-32V376c0-13.3-10.7-24-24-24s-24 10.7-24 24v88H504z"></path>
                  </svg>
                </span>
                <span className="menu-text"> Clients </span>{" "}
                {notifications?.clientData > 0 ? (
                  <>
                    {/* <span class="sidebarBadge">{notifications?.clientData}</span> */}
                    <span class="sidebarBadge1">
                      {/* {notifications?.clientData} */}
                    </span>
                  </>
                ) : null}
              </NavLink>
            ) : null}
            <div className="subMenuHover">
              {!userData?.data?.roleData?.[0]?.role_permission?.[3]
                ?.live_projects?.view &&
              !userData?.data?.roleData?.[0]?.role_permission?.[7]
                ?.completed_projects?.view &&
              !userData?.data?.roleData?.[0]?.role_permission?.[8]
                ?.archived_projects?.view ? null : (
                <Link className="position-relative">
                  <span className="menu-icon-new">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M2 3.75C2 2.784 2.784 2 3.75 2h16.5c.966 0 1.75.784 1.75 1.75v16.5A1.75 1.75 0 0 1 20.25 22H9.75a.75.75 0 0 1 0-1.5h10.5a.25.25 0 0 0 .25-.25V9h-17v3A.75.75 0 0 1 2 12ZM9 7.5h11.5V3.75a.25.25 0 0 0-.25-.25H9Zm-5.5 0h4v-4H3.75a.25.25 0 0 0-.25.25Z"></path>
                      <path d="m9.308 14.5-2.104-2.236a.75.75 0 1 1 1.092-1.028l3.294 3.5a.75.75 0 0 1 0 1.028l-3.294 3.5a.75.75 0 1 1-1.092-1.028L9.308 16H6.09a2.59 2.59 0 0 0-2.59 2.59v2.66a.75.75 0 0 1-1.5 0v-2.66a4.09 4.09 0 0 1 4.09-4.09h3.218Z"></path>
                    </svg>
                  </span>
                  <span className="menu-text"> Projects </span>{" "}
                  {notifications?.projectData > 0 ? (
                    <>
                      {/* <span className="sidebarBadge"> */}
                      <span className="sidebarBadge1">
                        {/* {notifications?.projectData} */}
                      </span>
                    </>
                  ) : null}
                </Link>
              )}
              <div className="subMenu">
                {!userData?.data?.roleData?.[0]?.role_permission?.[3]
                  ?.live_projects?.view &&
                !userData?.data?.roleData?.[0]?.role_permission?.[7]
                  ?.completed_projects?.view &&
                !userData?.data?.roleData?.[0]?.role_permission?.[8]
                  ?.archived_projects?.view ? null : (
                  <Link to="/dashboard/projects" style={{ marginLeft: "35px" }}>
                    <span className="menu-text"> Client Projects </span>{" "}
                  </Link>
                )}

                <Link
                  to="/dashboard/team/projects"
                  style={{ marginLeft: "35px" }}
                >
                  <span className="menu-text"> Team Projects </span>{" "}
                </Link>
              </div>
            </div>
            {userData?.data?.roleData?.[0]?.role_permission?.[16]
              ?.draftedZoomMeeting?.view === true && (
              <NavLink
                to="/dashboard/draft-zoom-meetings"
                activeclassname="menu_active"
              >
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    role="img"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title></title>
                    <path d="M4.585 13.607l-.27-.012H1.886l3.236-3.237-.013-.27a.815.815 0 00-.796-.796l-.27-.013H0l.014.27c.034.438.353.77.794.796l.27.013h2.43L.268 13.595l.014.269c.015.433.362.78.795.796l.27.013h4.046l-.014-.27c-.036-.443-.35-.767-.795-.795zm3.238-4.328h-.004a2.696 2.697 0 10.003 0zm1.141 3.841a1.619 1.619 0 11-2.289-2.288 1.619 1.619 0 012.289 2.288zM21.84 9.28a2.158 2.158 0 00-1.615.73 2.153 2.153 0 00-1.619-.732 2.148 2.148 0 00-1.208.37c-.21-.233-.68-.37-.949-.37v5.395l.27-.013c.45-.03.778-.349.796-.796l.013-.27v-1.889l.014-.27c.01-.202.04-.382.132-.54a1.078 1.079 0 011.473-.393 1.078 1.079 0 01.393.392c.093.16.12.34.132.54l.014.271v1.889l.013.269a.83.83 0 00.795.796l.27.013v-2.967l.012-.27c.01-.2.04-.384.134-.543.3-.514.96-.69 1.473-.39a1.078 1.079 0 01.393.393c.092.16.12.343.13.54l.015.27v1.889l.013.269c.028.443.35.77.796.796l.27.013v-3.237a2.158 2.158 0 00-2.16-2.156zm-10.263.788a2.697 2.698 0 103.811 3.816 2.697 2.698 0 00-3.811-3.816zm3.05 3.052a1.619 1.619 0 11-2.289-2.29 1.619 1.619 0 012.289 2.29z"></path>
                  </svg>
                </span>
                {/* //previously Zoom Draft Meeting */}
                <span className="menu-text">Calendar Invites</span>{" "}
              </NavLink>
            )}
            {userData?.data?.roleData?.[0]?.role_permission?.[5]?.call_records
              ?.view === true ? (
              <NavLink
                to="/dashboard/call_records"
                activeclassname="menu_active"
              >
                {" "}
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 512 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M320.9 19.054c-39.32 0-71 31.68-71 71s31.68 71 71 71 71-31.68 71-71-31.68-71-71-71zm0 30c22.537 0 41 18.463 41 41s-18.463 41-41 41-41-18.463-41-41 18.463-41 41-41zM146.5 64.42a37.825 37.825 0 0 0-8.3.83c-29.027 6.162-49.944 25.765-62.878 51.578-12.934 25.812-18.633 57.932-19.178 91.888-1.09 67.913 18.283 143.263 49.238 190.287 10.45 15.873 24.974 24.52 41.96 28.866 6.516 1.665 13.427 2.814 20.827 3.713a57.1 57.1 0 0 1-.27-5.53c0-4.142.572-8.306 1.642-12.485-6.597-.813-12.504-1.8-17.738-3.14-14.19-3.63-23.288-9.02-31.387-21.323-27.905-42.392-47.307-115.925-46.277-180.1.515-32.087 6.1-61.815 17.275-84.115 11.175-22.3 27.19-37.078 50.522-42.03 6.646-1.412 10.758-.17 15.23 3.33 4.473 3.503 8.925 9.938 12.633 18.57 6.386 14.87 10.5 35.725 13.035 56.294h18.133c-2.558-22.05-6.74-45.028-14.63-63.396-4.43-10.315-10.045-19.352-18.073-25.64-6.02-4.714-13.61-7.504-21.764-7.6zm174.4 2.634c-12.81 0-23 10.19-23 23s10.19 23 23 23 23-10.19 23-23-10.19-23-23-23zm-23 108.977v137.75c.14 3.726 1.945 6.4 6.222 9.108 4.293 2.717 10.887 4.59 17.405 4.78 6.517.19 12.843-1.326 16.732-3.762 3.888-2.436 5.64-4.806 5.64-9.852V176.03a88.702 88.702 0 0 1-23 3.024c-7.95 0-15.66-1.055-23-3.023zm-127.315 3.024c1.274 18.84 3.492 61.976-.802 88.442-2.047 12.612-7.35 26.95-11.577 37.558h69.385c-4.224-10.61-9.528-24.946-11.575-37.558-4.295-26.466-2.076-69.603-.803-88.442h-44.627zm63.315 16v30h46v-30h-46zm-89 126v18h96v-18h-96zm138.736 5.96c-27.298 14.694-51.16 32.19-68.373 49.403-19.15 19.152-29.363 38.137-29.363 49.637 0 13.182 5.877 23.69 16.293 33.068 10.415 9.378 25.387 17.005 41.552 22.393 45.724 15.24 108.584 15.24 154.307 0 16.166-5.388 31.137-13.015 41.553-22.393 10.416-9.377 16.295-19.886 16.295-33.068 0-21-10.155-38.33-29.022-55.31-16.857-15.172-40.628-29.394-68.123-43.57a30.515 30.515 0 0 1-10.94 11.988c-.07.042-.14.08-.208.123 17.422 2.965 33.142 8.79 45.972 16.875 19.12 12.05 32.32 29.83 32.32 50.394 0 20.566-13.2 38.345-32.32 50.395-19.12 12.048-44.638 19.104-72.68 19.104-28.043 0-53.562-7.056-72.682-19.105-19.12-12.05-32.318-29.83-32.318-50.396 0-20.565 13.2-38.345 32.318-50.394 13.266-8.36 29.617-14.31 47.75-17.174a42.995 42.995 0 0 1-1.47-.89c-4.3-2.72-8.18-6.5-10.862-11.08zm37.264 28.04c-24.977 0-47.46 6.487-63.084 16.334-15.626 9.848-23.916 22.32-23.916 35.166 0 12.848 8.29 25.32 23.916 35.166 15.625 9.848 38.107 16.334 63.084 16.334 15.375 0 29.797-2.465 42.263-6.652-4.685-3.872-9.765-8.13-14.255-12.965-3.65-3.93-6.973-8.283-9.022-13.594-2.05-5.31-2.506-11.822-.262-17.904l16.887 6.23c-.707 1.917-.64 3.096.17 5.195.81 2.098 2.68 4.874 5.42 7.824 5.012 5.398 12.588 11.12 19.345 17.054.86-.5 1.714-1.005 2.537-1.524 15.625-9.847 23.918-22.318 23.918-35.166 0-12.847-8.293-25.318-23.918-35.166-15.626-9.847-38.105-16.334-63.082-16.334zm-8.584 11.076h16v18h-16v-18zm38.006 5.383h16v18h-16v-18zm-72.506 3.137h16v18h-16v-18zm-27.98 26.404h16v18h-16v-18zm125.876 0h16v18h-16v-18zm-97.943 19.512h16v18h-16v-18zm34.782 8.762h16v18h-16v-18z"></path>
                  </svg>
                </span>{" "}
                <span className="menu-text"> Call Records </span>{" "}
              </NavLink>
            ) : null}
          </li>
        )}
        {userData?.data?.roleData?.[0]?.role_permission?.[14]?.qcExpert
          ?.view ? (
          <Divider
            className="m-0"
            style={{
              borderColor: "#5c5f623b",
            }}
          />
        ) : null}
        {userData?.data?.roleData?.[0]?.role_permission?.[14]?.qcExpert
          ?.view === true && (
          <li className="m-0">
            {/* <h5 style={{ fontWeight: 600 }}>QUALITY CHECK</h5> */}
            <NavLink to="/dashboard/temp_expert" activeclassname="menu_active">
              {" "}
              <span className="menu-icon-new">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 1024 1024"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M63.504 959.76l.002-64.942c0-25.44 19.103-33.424 26.72-36.944l281.04-132.624c20.143-9.248 34.047-28.32 36.752-50.32 2.72-22-6.16-43.84-23.457-57.712-66.48-53.376-97.456-170.704-97.456-233.185v-159.92c0-66.864 116.4-159.856 224.128-159.856 108.672 0 223.936 91.536 223.936 159.856v159.92c0 61.552-25.6 179.312-94.256 233.376a63.99 63.99 0 0 0-23.967 57.808c2.624 22.16 16.591 41.313 36.847 50.624l162.24 77.248 38.144-54.064-173.664-81.344c88.656-69.776 118.656-206.849 118.656-283.665v-159.92C799.169 118.176 652.545.241 511.233.241S223.105 118.177 223.105 224.096v159.92c0 69.872 31.888 211.248 121.392 283.088L63.457 799.76S-.495 828.256-.495 863.728v96.032c0 35.344 28.64 63.968 63.951 63.968h639.712l-52-63.984zm948.706-236.253c-13.904-10.912-34.032-8.432-44.912 5.473L830.45 937.684l-85.056-85.073c-12.496-12.496-32.768-12.496-45.264 0s-12.496 32.752 0 45.248l113.136 113.136c12.496 12.496 32.752 12.496 45.248 0 3.04-3.024 5.312-6.544 6.88-10.288l152.304-232.304c10.88-13.904 8.432-34.016-5.488-44.896z"></path>
                </svg>
              </span>{" "}
              <span className="menu-text"> Add Experts </span>{" "}
            </NavLink>

            <NavLink to="/dashboard/qc_experts" activeclassname="menu_active">
              {" "}
              <span className="menu-icon-new">
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  stroke-width="0"
                  viewBox="0 0 24 24"
                  height="1em"
                  width="1em"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M7.72.22a.75.75 0 0 1 1.06 0l1.204 1.203A4.98 4.98 0 0 1 12 1c.717 0 1.4.151 2.016.423L15.22.22a.751.751 0 0 1 1.042.018.751.751 0 0 1 .018 1.042l-.971.972A4.991 4.991 0 0 1 17 6v1.104a2.755 2.755 0 0 1 1.917 1.974l1.998-.999a.75.75 0 0 1 .67 1.342L19 10.714V13.5l3.25.003a.75.75 0 0 1 0 1.5L19 15.001V16c0 .568-.068 1.134-.204 1.686l.04.018 2.75 1.375a.75.75 0 1 1-.671 1.342l-2.638-1.319A6.998 6.998 0 0 1 12 23a6.998 6.998 0 0 1-6.197-3.742l-2.758 1.181a.752.752 0 0 1-1.064-.776.752.752 0 0 1 .474-.602l2.795-1.199A6.976 6.976 0 0 1 5 16v-.996H1.75a.75.75 0 0 1 0-1.5H5v-2.79L2.415 9.42a.75.75 0 0 1 .67-1.342l1.998.999A2.756 2.756 0 0 1 7 7.104V6a4.99 4.99 0 0 1 1.69-3.748l-.97-.972a.75.75 0 0 1 0-1.06ZM6.5 9.75V16a5.5 5.5 0 1 0 11 0V9.75c0-.69-.56-1.25-1.25-1.25h-8.5c-.69 0-1.25.56-1.25 1.25ZM8.5 7h7V6a3.5 3.5 0 1 0-7 0Z"></path>
                </svg>
              </span>{" "}
              <span className="menu-text"> QC Experts </span>{" "}
            </NavLink>

            {/* <NavLink
                  to="/dashboard/consulting"
                  activeclassname="menu_active"
                >
                  {" "}
                  <span className="menu-icon-new">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 24 24"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g>
                        <path fill="none" d="M0 0h24v24H0z"></path>
                        <path d="M14 14.252v2.09A6 6 0 0 0 6 22l-2-.001a8 8 0 0 1 10-7.748zM12 13c-3.315 0-6-2.685-6-6s2.685-6 6-6 6 2.685 6 6-2.685 6-6 6zm0-2c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm6 6v-3h2v3h3v2h-3v3h-2v-3h-3v-2h3z"></path>
                      </g>
                    </svg>
                  </span>{" "}
                  <span className="menu-text"> Consulting </span>{" "}
                </NavLink> */}
          </li>
        )}

        {userData?.data?.roleData?.[0]?.role_permission?.[6]?.expert_enquiry
          ?.view ||
        userData?.data?.roleData?.[0]?.role_permission?.[18]?.lead?.view ? (
          <Divider
            className="m-2"
            style={{
              borderColor: "#5c5f623b",
            }}
          />
        ) : null}

        {!userData?.data?.roleData?.[0]?.role_permission?.[6]?.expert_enquiry
          ?.view === true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[18]?.lead?.view ===
          true ? null : (
          <li className="m-0">
            {/* <h5 style={{ fontWeight: 600 }}>ADMIN</h5> */}
            {userData?.data?.roleData?.[0]?.role_permission?.[6]?.expert_enquiry
              ?.view === true ? (
              <NavLink
                to="/dashboard/enquiries"
                activeclassname="menu_active"
                className="position-relative"
              >
                {" "}
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 16 16"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M4 4a3 3 0 0 0-3 3v6h6V7a3 3 0 0 0-3-3zm0-1h8a4 4 0 0 1 4 4v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a4 4 0 0 1 4-4zm2.646 1A3.99 3.99 0 0 1 8 7v6h7V7a3 3 0 0 0-3-3H6.646z"></path>
                    <path d="M11.793 8.5H9v-1h5a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.354-.146l-.853-.854zM5 7c0 .552-.448 0-1 0s-1 .552-1 0a1 1 0 0 1 2 0z"></path>
                  </svg>
                </span>{" "}
                <span className="menu-text"> Enquiries </span>{" "}
                {/* <span className="sidebarBadge">9+</span> */}
              </NavLink>
            ) : null}

            {userData?.data?.roleData?.[0]?.role_permission?.[18]?.lead
              ?.view === true && (
              <NavLink to="/dashboard/lead" activeclassname="menu_active">
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    role="img"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title></title>
                    <path d="M22.056 8.447a3.894 3.894 0 0 0-5.313 1.419l-3.889 6.72a3.874 3.874 0 0 0 1.415 5.293l.01.005a3.894 3.894 0 0 0 5.312-1.42l3.889-6.718a3.875 3.875 0 0 0-1.416-5.294l-.008-.005m-14.7 12.168c-1.08 1.888-3.514 2.583-5.384 1.493-1.87-1.09-2.533-3.455-1.453-5.343s3.494-2.586 5.365-1.496c1.87 1.09 2.554 3.457 1.474 5.344m4.131-19.228a3.935 3.935 0 0 0-3.267 2.189l-3.67 6.279a4.638 4.638 0 0 0-.227.387l-2.746 4.737c1.345-.86 3.09-.993 4.55-.143a4.456 4.456 0 0 1 2.22 4.041l2.77-4.763c.082-.124.157-.252.224-.385l3.67-6.281a3.86 3.86 0 0 0-1.283-5.55 3.958 3.958 0 0 0-2.24-.511z"></path>
                  </svg>
                </span>
                <span className="menu-text"> Leads </span>{" "}
              </NavLink>
            )}
          </li>
        )}
        {userData?.data?.roleData?.[0]?.role_permission?.[10]?.roles?.view &&
        userData?.data?.roleData?.[0]?.role_permission?.[9]?.managers?.view &&
        userData?.data?.roleData?.[0]?.role_permission?.[1]?.client?.view ? (
          <Divider
            className="m-2"
            style={{
              borderColor: "#5c5f623b",
            }}
          />
        ) : null}

        {!userData?.data?.roleData?.[0]?.role_permission?.[10]?.roles?.view ===
          true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[9]?.managers?.view ===
          true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[1]?.client?.view ===
          true ? null : (
          <li className="m-0">
            {/* <h5 style={{ fontWeight: 600 }}>SUPER ADMIN</h5> */}

            {userData?.data?.roleData?.[0]?.role_permission?.[10]?.roles
              ?.view === true ? (
              <NavLink to="/dashboard/roles" activeclassname="menu_active">
                {" "}
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 448 512"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M225.82 0c.26.15 216.57 124.51 217.12 124.72 3 1.18 3.7 3.46 3.7 6.56q-.11 125.17 0 250.36a5.88 5.88 0 0 1-3.38 5.78c-21.37 12-207.86 118.29-218.93 124.58h-3C142 466.34 3.08 386.56 2.93 386.48a3.29 3.29 0 0 1-1.88-3.24c0-.87 0-225.94-.05-253.1a5 5 0 0 1 2.93-4.93C27.19 112.11 213.2 6 224.07 0zM215.4 20.42l-.22-.16Q118.06 75.55 21 130.87c0 .12.08.23.13.35l30.86 11.64c-7.71 6-8.32 6-10.65 5.13-.1 0-24.17-9.28-26.8-10v230.43c.88-1.41 64.07-110.91 64.13-111 1.62-2.82 3-1.92 9.12-1.52 1.4.09 1.48.22.78 1.42-41.19 71.33-36.4 63-67.48 116.94-.81 1.4-.61 1.13 1.25 1.13h186.5c1.44 0 1.69-.23 1.7-1.64v-8.88c0-1.34 2.36-.81-18.37-1-7.46-.07-14.14-3.22-21.38-12.7-7.38-9.66-14.62-19.43-21.85-29.21-2.28-3.08-3.45-2.38-16.76-2.38-1.75 0-1.78 0-1.76 1.82.29 26.21.15 25.27 1 32.66.52 4.37 2.16 4.2 9.69 4.81 3.14.26 3.88 4.08.52 4.92-1.57.39-31.6.51-33.67-.1a2.42 2.42 0 0 1 .3-4.73c3.29-.76 6.16.81 6.66-4.44 1.3-13.66 1.17-9 1.1-79.42 0-10.82-.35-12.58-5.36-13.55-1.22-.24-3.54-.16-4.69-.55-2.88-1-2-4.84 1.77-4.85 33.67 0 46.08-1.07 56.06 4.86 7.74 4.61 12 11.48 12.51 20.4.88 14.59-6.51 22.35-15 32.59a1.46 1.46 0 0 0 0 2.22c2.6 3.25 5 6.63 7.71 9.83 27.56 33.23 24.11 30.54 41.28 33.06.89.13 1-.42 1-1.15v-11c0-1 .32-1.43 1.41-1.26a72.37 72.37 0 0 0 23.58-.3c1.08-.15 1.5.2 1.48 1.33 0 .11.88 26.69.87 26.8-.05 1.52.67 1.62 1.89 1.62h186.71Q386.51 304.6 346 234.33c2.26-.66-.4 0 6.69-1.39 2-.39 2.05-.41 3.11 1.44 7.31 12.64 77.31 134 77.37 134.06V138c-1.72.5-103.3 38.72-105.76 39.68-1.08.42-1.55.2-1.91-.88-.63-1.9-1.34-3.76-2.09-5.62-.32-.79-.09-1.13.65-1.39.1 0 95.53-35.85 103-38.77-65.42-37.57-130.56-75-196-112.6l86.82 150.39-.28.33c-9.57-.9-10.46-1.6-11.8-3.94-1-1.69-73.5-127.71-82-142.16-9.1 14.67-83.56 146.21-85.37 146.32-2.93.17-5.88.08-9.25.08q43.25-74.74 86.18-149zm51.93 129.92a37.68 37.68 0 0 0 5.54-.85c1.69-.3 2.53.2 2.6 1.92 0 .11.07 19.06-.86 20.45s-1.88 1.22-2.6-.19c-5-9.69 6.22-9.66-39.12-12-.7 0-1 .23-1 .93 0 .13 3.72 122 3.73 122.11 0 .89.52 1.2 1.21 1.51a83.92 83.92 0 0 1 8.7 4.05c7.31 4.33 11.38 10.84 12.41 19.31 1.44 11.8-2.77 35.77-32.21 37.14-2.75.13-28.26 1.08-34.14-23.25-4.66-19.26 8.26-32.7 19.89-36.4a2.45 2.45 0 0 0 2-2.66c.1-5.63 3-107.1 3.71-121.35.05-1.08-.62-1.16-1.35-1.15-32.35.52-36.75-.34-40.22 8.52-2.42 6.18-4.14 1.32-3.95.23q1.59-9 3.31-18c.4-2.11 1.43-2.61 3.43-1.86 5.59 2.11 6.72 1.7 37.25 1.92 1.73 0 1.78-.08 1.82-1.85.68-27.49.58-22.59 1-29.55a2.69 2.69 0 0 0-1.63-2.8c-5.6-2.91-8.75-7.55-8.9-13.87-.35-14.81 17.72-21.67 27.38-11.51 6.84 7.19 5.8 18.91-2.45 24.15a4.35 4.35 0 0 0-2.22 4.34c0 .59-.11-4.31 1 30.05 0 .9.43 1.12 1.24 1.11.1 0 23-.09 34.47-.37zM68.27 141.7c19.84-4.51 32.68-.56 52.49 1.69 2.76.31 3.74 1.22 3.62 4-.21 5-1.16 22.33-1.24 23.15a2.65 2.65 0 0 1-1.63 2.34c-4.06 1.7-3.61-4.45-4-7.29-3.13-22.43-73.87-32.7-74.63 25.4-.31 23.92 17 53.63 54.08 50.88 27.24-2 19-20.19 24.84-20.47a2.72 2.72 0 0 1 3 3.36c-1.83 10.85-3.42 18.95-3.45 19.15-1.54 9.17-86.7 22.09-93.35-42.06-2.71-25.85 10.44-53.37 40.27-60.15zm80 87.67h-19.49a2.57 2.57 0 0 1-2.66-1.79c2.38-3.75 5.89.92 5.86-6.14-.08-25.75.21-38 .23-40.1 0-3.42-.53-4.65-3.32-4.94-7-.72-3.11-3.37-1.11-3.38 11.84-.1 22.62-.18 30.05.72 8.77 1.07 16.71 12.63 7.93 22.62-2 2.25-4 4.42-6.14 6.73.95 1.15 6.9 8.82 17.28 19.68 2.66 2.78 6.15 3.51 9.88 3.13a2.21 2.21 0 0 0 2.23-2.12c.3-3.42.26 4.73.45-40.58 0-5.65-.34-6.58-3.23-6.83-3.95-.35-4-2.26-.69-3.37l19.09-.09c.32 0 4.49.53 1 3.38 0 .05-.16 0-.24 0-3.61.26-3.94 1-4 4.62-.27 43.93.07 40.23.41 42.82.11.84.27 2.23 5.1 2.14 2.49 0 3.86 3.37 0 3.4-10.37.08-20.74 0-31.11.07-10.67 0-13.47-6.2-24.21-20.82-1.6-2.18-8.31-2.36-8.2-.37.88 16.47 0 17.78 4 17.67 4.75-.1 4.73 3.57.83 3.55zm275-10.15c-1.21 7.13.17 10.38-5.3 10.34-61.55-.42-47.82-.22-50.72-.31a18.4 18.4 0 0 1-3.63-.73c-2.53-.6 1.48-1.23-.38-5.6-1.43-3.37-2.78-6.78-4.11-10.19a1.94 1.94 0 0 0-2-1.44 138 138 0 0 0-14.58.07 2.23 2.23 0 0 0-1.62 1.06c-1.58 3.62-3.07 7.29-4.51 11-1.27 3.23 7.86 1.32 12.19 2.16 3 .57 4.53 3.72.66 3.73H322.9c-2.92 0-3.09-3.15-.74-3.21a6.3 6.3 0 0 0 5.92-3.47c1.5-3 2.8-6 4.11-9.09 18.18-42.14 17.06-40.17 18.42-41.61a1.83 1.83 0 0 1 3 0c2.93 3.34 18.4 44.71 23.62 51.92 2 2.7 5.74 2 6.36 2 3.61.13 4-1.11 4.13-4.29.09-1.87.08 1.17.07-41.24 0-4.46-2.36-3.74-5.55-4.27-.26 0-2.56-.63-.08-3.06.21-.2-.89-.24 21.7-.15 2.32 0 5.32 2.75-1.21 3.45a2.56 2.56 0 0 0-2.66 2.83c-.07 1.63-.19 38.89.29 41.21a3.06 3.06 0 0 0 3.23 2.43c13.25.43 14.92.44 16-3.41 1.67-5.78 4.13-2.52 3.73-.19zm-104.72 64.37c-4.24 0-4.42-3.39-.61-3.41 35.91-.16 28.11.38 37.19-.65 1.68-.19 2.38.24 2.25 1.89-.26 3.39-.64 6.78-1 10.16-.25 2.16-3.2 2.61-3.4-.15-.38-5.31-2.15-4.45-15.63-5.08-1.58-.07-1.64 0-1.64 1.52V304c0 1.65 0 1.6 1.62 1.47 3.12-.25 10.31.34 15.69-1.52.47-.16 3.3-1.79 3.07 1.76 0 .21-.76 10.35-1.18 11.39-.53 1.29-1.88 1.51-2.58.32-1.17-2 0-5.08-3.71-5.3-15.42-.9-12.91-2.55-12.91 6 0 12.25-.76 16.11 3.89 16.24 16.64.48 14.4 0 16.43-5.71.84-2.37 3.5-1.77 3.18.58-.44 3.21-.85 6.43-1.23 9.64 0 .36-.16 2.4-4.66 2.39-37.16-.08-34.54-.19-35.21-.31-2.72-.51-2.2-3 .22-3.45 1.1-.19 4 .54 4.16-2.56 2.44-56.22-.07-51.34-3.91-51.33zm-.41-109.52c2.46.61 3.13 1.76 2.95 4.65-.33 5.3-.34 9-.55 9.69-.66 2.23-3.15 2.12-3.34-.27-.38-4.81-3.05-7.82-7.57-9.15-26.28-7.73-32.81 15.46-27.17 30.22 5.88 15.41 22 15.92 28.86 13.78 5.92-1.85 5.88-6.5 6.91-7.58 1.23-1.3 2.25-1.84 3.12 1.1 0 .1.57 11.89-6 12.75-1.6.21-19.38 3.69-32.68-3.39-21-11.19-16.74-35.47-6.88-45.33 14-14.06 39.91-7.06 42.32-6.47zM289.8 280.14c3.28 0 3.66 3 .16 3.43-2.61.32-5-.42-5 5.46 0 2-.19 29.05.4 41.45.11 2.29 1.15 3.52 3.44 3.65 22 1.21 14.95-1.65 18.79-6.34 1.83-2.24 2.76.84 2.76 1.08.35 13.62-4 12.39-5.19 12.4l-38.16-.19c-1.93-.23-2.06-3-.42-3.38 2-.48 4.94.4 5.13-2.8 1-15.87.57-44.65.34-47.81-.27-3.77-2.8-3.27-5.68-3.71-2.47-.38-2-3.22.34-3.22 1.45-.02 17.97-.03 23.09-.02zm-31.63-57.79c.07 4.08 2.86 3.46 6 3.58 2.61.1 2.53 3.41-.07 3.43-6.48 0-13.7 0-21.61-.06-3.84 0-3.38-3.35 0-3.37 4.49 0 3.24 1.61 3.41-45.54 0-5.08-3.27-3.54-4.72-4.23-2.58-1.23-1.36-3.09.41-3.15 1.29 0 20.19-.41 21.17.21s1.87 1.65-.42 2.86c-1 .52-3.86-.28-4.15 2.47 0 .21-.82 1.63-.07 43.8zm-36.91 274.27a2.93 2.93 0 0 0 3.26 0c17-9.79 182-103.57 197.42-112.51-.14-.43 11.26-.18-181.52-.27-1.22 0-1.57.37-1.53 1.56 0 .1 1.25 44.51 1.22 50.38a28.33 28.33 0 0 1-1.36 7.71c-.55 1.83.38-.5-13.5 32.23-.73 1.72-1 2.21-2-.08-4.19-10.34-8.28-20.72-12.57-31a23.6 23.6 0 0 1-2-10.79c.16-2.46.8-16.12 1.51-48 0-1.95 0-2-2-2h-183c2.58 1.63 178.32 102.57 196 112.76zm-90.9-188.75c0 2.4.36 2.79 2.76 3 11.54 1.17 21 3.74 25.64-7.32 6-14.46 2.66-34.41-12.48-38.84-2-.59-16-2.76-15.94 1.51.05 8.04.01 11.61.02 41.65zm105.75-15.05c0 2.13 1.07 38.68 1.09 39.13.34 9.94-25.58 5.77-25.23-2.59.08-2 1.37-37.42 1.1-39.43-14.1 7.44-14.42 40.21 6.44 48.8a17.9 17.9 0 0 0 22.39-7.07c4.91-7.76 6.84-29.47-5.43-39a2.53 2.53 0 0 1-.36.12zm-12.28-198c-9.83 0-9.73 14.75-.07 14.87s10.1-14.88.07-14.91zm-80.15 103.83c0 1.8.41 2.4 2.17 2.58 13.62 1.39 12.51-11 12.16-13.36-1.69-11.22-14.38-10.2-14.35-7.81.05 4.5-.03 13.68.02 18.59zm212.32 6.4l-6.1-15.84c-2.16 5.48-4.16 10.57-6.23 15.84z"></path>
                  </svg>
                </span>{" "}
                <span className="menu-text"> Roles </span>{" "}
              </NavLink>
            ) : null}

            {userData?.data?.roleData?.[0]?.role_permission?.[9]?.managers
              ?.view === true ? (
              <NavLink to="/dashboard/managers" activeclassname="menu_active">
                {" "}
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                    <path d="M4 18v-.65c0-.34.16-.66.41-.81C6.1 15.53 8.03 15 10 15c.03 0 .05 0 .08.01.1-.7.3-1.37.59-1.98-.22-.02-.44-.03-.67-.03-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.42-.6-.75-1.28-.97-2H4zM10 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0-6c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"></path>
                  </svg>
                </span>{" "}
                {/* <span className="menu-text"> Managers </span>{" "} */}
                <span className="menu-text"> Users </span>{" "}
              </NavLink>
            ) : null}

            {/* <NavLink to="/dashboard/logs" activeclassname="menu_active">
                  {" "}
                  <span className="menu-icon-new">
                    <svg
                      stroke="currentColor"
                      fill="currentColor"
                      stroke-width="0"
                      viewBox="0 0 16 16"
                      height="1em"
                      width="1em"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path d="M7.29333 9.00631L6.41333 9.88552C6.27949 9.34717 5.96917 8.86905 5.53181 8.52735C5.09445 8.18564 4.55521 8 4 8C3.44479 8 2.90555 8.18564 2.46819 8.52735C2.03083 8.86905 1.72051 9.34717 1.58667 9.88552L0.706667 9.00631L0 9.71234L1.14667 10.858L1 11.0045V12.0036H0V13.0027H1V13.056C1.051 13.3815 1.14283 13.6993 1.27333 14.0018L0 15.294L0.706667 16L1.80667 14.901C2.06838 15.2346 2.40078 15.5062 2.78001 15.6962C3.15924 15.8862 3.57587 15.99 4 16C4.42413 15.99 4.84076 15.8862 5.21999 15.6962C5.59922 15.5062 5.93162 15.2346 6.19333 14.901L7.29333 16L8 15.294L6.72667 14.0018C6.85879 13.6929 6.95065 13.3683 7 13.036V12.9694H8V12.0036H7V11.0045L6.85333 10.858L8 9.71234L7.29333 9.00631ZM4 9.00631C4.39782 9.00631 4.77936 9.16421 5.06066 9.44526C5.34196 9.72631 5.5 10.1075 5.5 10.505H2.5C2.5 10.1075 2.65804 9.72631 2.93934 9.44526C3.22064 9.16421 3.60218 9.00631 4 9.00631ZM6 13.0027C5.95116 13.5161 5.72476 13.9965 5.35974 14.3612C4.99472 14.7259 4.5139 14.9521 4 15.0009C3.4861 14.9521 3.00528 14.7259 2.64026 14.3612C2.27524 13.9965 2.04884 13.5161 2 13.0027V11.5041H6V13.0027Z"></path>
                      <path
                        fill-rule="evenodd"
                        clip-rule="evenodd"
                        d="M3.77951 2L2.99951 2.41V7H3.99951V3.35L11.5995 8.42L9 10.1507V11.3497L12.7795 8.83V8L3.77951 2ZM9 13.3497V12.1482L14.5995 8.42006L6.99951 3.35006V2.14673L15.7795 8.00006V8.83006L9 13.3497Z"
                      ></path>
                    </svg>
                  </span>
                  <span className="menu-text"> Logs </span>{" "}
                </NavLink> */}
          </li>
        )}
        {userData?.data?.roleData?.[0]?.role_permission?.[13]?.internalMeeting
          ?.view ||
        userData?.data?.roleData?.[0]?.role_permission?.[17]?.creditManagement
          ?.view ? (
          <Divider
            className="m-2"
            style={{
              borderColor: "#5c5f623b",
            }}
          />
        ) : null}
        {!userData?.data?.roleData?.[0]?.role_permission?.[13]?.internalMeeting
          ?.view === true &&
        !userData?.data?.roleData?.[0]?.role_permission?.[17]?.creditManagement
          ?.view === true ? null : (
          <li className="m-0">
            {/* <h5 style={{ fontWeight: 600 }}>CLOUD FEATURES</h5> */}
            {userData?.data?.roleData?.[0]?.role_permission?.[13]
              ?.internalMeeting?.view === true && (
              <NavLink
                onClick={() => dispatch(setMeetingPage(1))}
                to="/dashboard/cloud-feature/internal-meetings"
                activeclassname="menu_active"
              >
                {" "}
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    role="img"
                    viewBox="0 0 24 24"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <title></title>
                    <path d="M4.585 13.607l-.27-.012H1.886l3.236-3.237-.013-.27a.815.815 0 00-.796-.796l-.27-.013H0l.014.27c.034.438.353.77.794.796l.27.013h2.43L.268 13.595l.014.269c.015.433.362.78.795.796l.27.013h4.046l-.014-.27c-.036-.443-.35-.767-.795-.795zm3.238-4.328h-.004a2.696 2.697 0 10.003 0zm1.141 3.841a1.619 1.619 0 11-2.289-2.288 1.619 1.619 0 012.289 2.288zM21.84 9.28a2.158 2.158 0 00-1.615.73 2.153 2.153 0 00-1.619-.732 2.148 2.148 0 00-1.208.37c-.21-.233-.68-.37-.949-.37v5.395l.27-.013c.45-.03.778-.349.796-.796l.013-.27v-1.889l.014-.27c.01-.202.04-.382.132-.54a1.078 1.079 0 011.473-.393 1.078 1.079 0 01.393.392c.093.16.12.34.132.54l.014.271v1.889l.013.269a.83.83 0 00.795.796l.27.013v-2.967l.012-.27c.01-.2.04-.384.134-.543.3-.514.96-.69 1.473-.39a1.078 1.079 0 01.393.393c.092.16.12.343.13.54l.015.27v1.889l.013.269c.028.443.35.77.796.796l.27.013v-3.237a2.158 2.158 0 00-2.16-2.156zm-10.263.788a2.697 2.698 0 103.811 3.816 2.697 2.698 0 00-3.811-3.816zm3.05 3.052a1.619 1.619 0 11-2.289-2.29 1.619 1.619 0 012.289 2.29z"></path>
                  </svg>
                </span>{" "}
                <span className="menu-text"> Internal Meetings </span>{" "}
              </NavLink>
            )}
            {userData?.data?.roleData?.[0]?.role_permission?.[17]
              ?.creditManagement?.view === true && (
              <NavLink
                to="/dashboard/cloud-feature/credit-management"
                activeclassname="menu_active"
              >
                {" "}
                <span className="menu-icon-new">
                  <svg
                    stroke="currentColor"
                    fill="currentColor"
                    stroke-width="0"
                    viewBox="0 0 16 16"
                    height="1em"
                    width="1em"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path d="M14 3a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h12zM2 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H2z"></path>
                    <path d="M2 5.5a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1zm0 3a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5zm0 2a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5zm3 0a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 0 1h-1a.5.5 0 0 1-.5-.5z"></path>
                  </svg>
                </span>{" "}
                <span className="menu-text"> Credit Management </span>{" "}
              </NavLink>
            )}
            {/* <NavLink
            to="/dashboard/clients"
            activeclassname="menu_active"
            className="position-relative"
          >
            <span className="menu-icon-new">
              <svg
                stroke="currentColor"
                fill="currentColor"
                stroke-width="0"
                viewBox="0 0 1024 1024"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z"></path>
              </svg>
            </span>
            <span className="menu-text"> Transactions </span>{" "}
          </NavLink> */}
          </li>
        )}
        <Divider
          className="m-2"
          style={{
            borderColor: "#5c5f623b",
          }}
        />

        <li className="m-0">
          {/* <h5 style={{ fontWeight: 600 }}>HR & POLICIES</h5> */}
          <NavLink
            target="_blank"
            rel="noopener noreferrer"
            to="https://app.keka.com/Account/Login?ReturnUrl=%2F"
            activeclassname="menu_active"
          >
            <span className="menu-icon-new">
              <svg
                stroke="currentColor"
                fill="none"
                stroke-width="2"
                viewBox="0 0 24 24"
                stroke-linecap="round"
                stroke-linejoin="round"
                height="1em"
                width="1em"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M13 20.94a8.916 8.916 0 0 1 -7.364 -2.576a9 9 0 1 1 15.306 -5.342"></path>
                <path d="M12 7v5l2 2"></path>
                <path d="M17 17v5"></path>
                <path d="M21 17v5"></path>
              </svg>
            </span>
            <span className="menu-text"> HR Dashboard </span>{" "}
          </NavLink>

          <a href={hr_policy} target="_blank">
            <span className="menu-icon-new">
              <AiOutlineFileDone />
            </span>
            <span className="menu-text"> HR Policy Manual </span>{" "}
          </a>
        </li>

        <li className="d-lg-none">
          {/* <h5 style={{ fontWeight: 600 }}>ACCOUNT SETTING</h5> */}
          <NavLink
            to={"/dashboard/profile"}
            onClick={() => setProfilePopover(false)}
            className={"menu-text d-flex align-items-center"}
            activeclassname="menu_active"
          >
            <IoSettingsOutline className="me-2 fs-5" /> Account Setting
          </NavLink>
          <NavLink
            to={"/notification"}
            onClick={() => setProfilePopover(false)}
            className={"menu-text d-flex align-items-center position-relative"}
            activeclassname="menu_active"
          >
            <BsBell className="me-2 fs-5" /> Notifications
            {notifications?.totalNoti > 0 ? (
              <>
                {/* <span
                  style={{ right: "10px" }}
                  className="sidebarBadge position-absolute"
                >
                  {notifications?.totalNoti}
                </span> */}
                <span
                  style={{ right: "10px" }}
                  className="sidebarBadge1 position-absolute"
                >
                  {notifications?.totalNoti}
                </span>
              </>
            ) : null}
          </NavLink>
          <NavLink
            to={"/dashboard/change-password"}
            activeclassname="menu_active"
            className={"menu-text d-flex align-items-center"}
            onClick={() => setProfilePopover(false)}
          >
            <IoOpenOutline className="me-2 fs-5" /> Change Password
          </NavLink>
          <NavLink
            // to={"/admin-login"}
            onClick={handleLogout}
            activeclassname="menu_active"
            className={"menu-text d-flex align-items-center"}
          >
            <AiOutlineLogout className="me-2 fs-5" /> Logout
          </NavLink>
        </li>
      </ul>
    );
  };

  return (
    <>
      <div className="sidebar-menu d-none d-lg-block" id="navAccordion">
        <div className="inside0div">
          <div className="logo-admin">
            <NavLink to="/dashboard">
              <img src={nextyn_logo} alt="logo" />
            </NavLink>
          </div>

          <div className="main-menu d-none d-lg-block" ref={wrapperRef}>
            {menuItems()}
            <div className="userProfileWrapper">
              <Popover
                overlayClassName="customAntPop"
                placement="bottomRight"
                trigger={["click", "hover"]}
                content={
                  // <div className={`profilePopover`}>
                  <div className="">
                    {/* <div className={`positibsw ${profilePopover && "active"}`}> */}
                    <div>
                      <div className="d-flex align-items-center">
                        <Avatar
                          style={{
                            backgroundColor: "#EFEFEF",
                            color: "#f33636",
                            height: "30px",
                            width: "30px",
                          }}
                          alt={userData?.data?.name}
                        >
                          {userData?.data?.name?.charAt(0)?.toUpperCase()}
                        </Avatar>
                        <div className="profileSidebarDetails">
                          <h5>{userData?.data?.name}</h5>
                          <p>{userData?.data?.email}</p>
                        </div>
                      </div>
                      <hr />
                      <ul className="profileUl">
                        <li>
                          <NavLink
                            to={"/dashboard/profile"}
                            onClick={() => setProfilePopover(false)}
                            className="d-flex align-items-center"
                          >
                            <IoSettingsOutline className="me-2 fs-5" /> Account
                            Setting
                          </NavLink>
                        </li>
                        {/* <li>
              <NavLink
                to={"/dashboard/notification"}
                onClick={() => setProfilePopover(false)}
                className="d-flex align-items-center position-relative"
              >
                <BsBell className="me-2 fs-5" /> Notifications
                {notifications?.totalNoti > 0 ? (
                  <>
                    <span
                      style={{ right: "10px" }}
                      className="sidebarBadge1 position-absolute"
                    >
                    </span>
                  </>
                ) : null}
              </NavLink>
            </li> */}
                        <li>
                          <NavLink
                            to={"/dashboard/change-password"}
                            className="d-flex align-items-center"
                            onClick={() => setProfilePopover(false)}
                          >
                            <IoOpenOutline className="me-2 fs-5" /> Change
                            Password
                          </NavLink>
                        </li>
                        <li>
                          <NavLink
                            // to={"/admin-login"}
                            onClick={handleLogout}
                            className="d-flex align-items-center"
                          >
                            <AiOutlineLogout className="me-2 fs-5" /> Logout
                          </NavLink>
                        </li>
                      </ul>
                    </div>
                  </div>
                }
              >
                <div className="user_Profiles">
                  <div
                    className="d-flex align-items-center justify-content-between p-2"
                    style={{ cursor: "pointer" }}
                    onClick={() => setProfilePopover(!profilePopover)}
                  >
                    <div className="d-flex align-items-center">
                      <Avatar
                        style={{
                          backgroundColor: "#EFEFEF",
                          color: "#f33636",
                          height: "30px",
                          width: "30px",
                        }}
                        alt={userData?.data?.name}
                      >
                        {userData?.data?.name?.charAt(0)?.toUpperCase()}
                      </Avatar>
                      <div className="profileSidebarDetails">
                        <h5>{userData?.data?.name}</h5>
                        <p>{userData?.data?.email}</p>
                      </div>
                    </div>
                    <div>
                      <SlArrowRight />
                    </div>
                  </div>
                </div>
              </Popover>
            </div>
          </div>
        </div>
      </div>

      {/* <div className={`profilePopover`}>
        <div className={`positibsw ${profilePopover && "active"}`}>
          <div className="d-flex align-items-center">
            <Avatar
              style={{
                backgroundColor: "#EFEFEF",
                color: "#f33636",
                height: "30px",
                width: "30px",
              }}
              alt={userData?.data?.name}
            >
              {userData?.data?.name?.charAt(0)?.toUpperCase()}
            </Avatar>
            <div className="profileSidebarDetails">
              <h5>{userData?.data?.name}</h5>
              <p>{userData?.data?.email}</p>
            </div>
          </div>
          <hr />
          <ul className="profileUl">
            <li>
              <NavLink
                to={"/dashboard/profile"}
                onClick={() => setProfilePopover(false)}
                className="d-flex align-items-center"
              >
                <IoSettingsOutline className="me-2 fs-5" /> Account Setting
              </NavLink>
            </li>
            {/* <li>
              <NavLink
                to={"/dashboard/notification"}
                onClick={() => setProfilePopover(false)}
                className="d-flex align-items-center position-relative"
              >
                <BsBell className="me-2 fs-5" /> Notifications
                {notifications?.totalNoti > 0 ? (
                  <>
                    <span
                      style={{ right: "10px" }}
                      className="sidebarBadge1 position-absolute"
                    >
                    </span>
                  </>
                ) : null}
              </NavLink>
            </li> */}
      {/* <li>
              <NavLink
                to={"/dashboard/change-password"}
                className="d-flex align-items-center"
                onClick={() => setProfilePopover(false)}
              >
                <IoOpenOutline className="me-2 fs-5" /> Change Password
              </NavLink>
            </li>
            <li>
              <NavLink
                // to={"/admin-login"}
                onClick={handleLogout}
                className="d-flex align-items-center"
              >
                <AiOutlineLogout className="me-2 fs-5" /> Logout
              </NavLink>
            </li>
          </ul>
        </div> */}
      {/* </div> */}

      <div className="mobileMenu d-lg-none">
        <div className="d-flex align-items-center justify-content-between">
          <NavLink to="/dashboard">
            <img src={nextyn_logo} alt="logo" style={{ width: "150px" }} />
          </NavLink>
          <div className="mobileHamburger" onClick={handleShow}>
            <RxHamburgerMenu />
          </div>
        </div>
      </div>

      <Offcanvas
        show={show}
        onHide={handleClose}
        placement={"end"}
        backdrop={true}
        className="menuBarOffCanvas"
      >
        <Offcanvas.Header className="menu-offCanvas" closeButton>
          <NavLink to="/dashboard">
            <img src={nextyn_logo} alt="logo" style={{ width: "150px" }} />
          </NavLink>
        </Offcanvas.Header>
        <Offcanvas.Body className="mobileMenuBody">
          {menuItems()}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}
export default Sidebar;
